import {PossessedStatics} from "../config/PossessedStatics";
import {Possessed} from "../Possessed";
import {SimpleReelModelState} from "../../core/reel/simplereel/SimpleReelModel";
import {gsap} from "gsap"
import {PossessedGameAssets} from "../PossessedGameAssets";
import {CustomEase} from "gsap/dist/CustomEase";

export class ExorcismMysteryReel extends PIXI.Container {

    public readonly reelID:number
    public readonly reelPosition:number;

    private reelSet:string[] = [];
    public updateReelSet(set:string[]) {
        this.reelSet = set;
    }

    public stepSize:number = PossessedStatics.SYMBOL_HEIGHT;
    public stepDuration:number = 0.05;
    private shouldStop:boolean = false;
    private firstStep:boolean = false;
    private animatedStepData = {
        y: 0
    };
    
    public isFullCross:boolean = false;

    private symbols:PIXI.Sprite[] = [];
    public GetSymbolSpriteAt(index:number):PIXI.Sprite {
        return this.symbols[index];
    }

    private masterTimeline:gsap.core.Timeline;

    private state:SimpleReelModelState = SimpleReelModelState.IDLE;
    public getState() : SimpleReelModelState {
        return this.state;
    }

    private reelMask:PIXI.Graphics;

    constructor(reelID:number, reelPosition:number) {
        super();
        this.name = "MysteryReel";
        this.reelID = reelID;
        this.reelPosition = reelPosition;
    }

    public init() {
         // Create mask
         this.reelMask = new PIXI.Graphics();
         this.reelMask.beginFill();
         const symWidth = PossessedStatics.SYMBOL_WIDTH;
         const symHeight = PossessedStatics.SYMBOL_HEIGHT;
         this.reelMask.drawRect(this.reelID * symWidth, -symHeight / 2.0, symWidth, symHeight);
         this.mask = this.reelMask;
         this.addChild(this.reelMask);
 
         // Create symbol sprites
         for(let i:number=0; i < 3; i++) {
            const sp = new PIXI.Sprite(PIXI.Texture.WHITE);
            sp.width = PossessedStatics.SYMBOL_WIDTH;
            sp.height = PossessedStatics.SYMBOL_HEIGHT;
            sp.anchor.set(0.5, 0.5);
            sp.position.set(this.reelID * PossessedStatics.SYMBOL_WIDTH + (PossessedStatics.SYMBOL_WIDTH/2), -this.stepSize + (i * this.stepSize));
            this.symbols.push(sp);
            this.addChild(sp);
         }
 
         this.masterTimeline = gsap.timeline({
             paused: true
         });
 
         this.visible = false;
    }

    public start(reverse:boolean = true) {
        this.masterTimeline = gsap.timeline()
            .add(() => {
                this.visible = true;
                this.symbols[1].visible = false;
                this.firstStep = true;
                this.shouldStop = false;
                this.state = SimpleReelModelState.SPIN;
            })
            .add(this.spin(reverse))
    }
    public stop(stopSymbol:string, stopDuration:number=0.3, reverse:boolean = false) {
        const stopTL = gsap.timeline()
            .add(() => {
                this.shouldStop = true;
                this.state = SimpleReelModelState.STOP;
            })
            .add(this.step(stopSymbol, reverse, stopDuration, CustomEase.create("custom", "M0,0,C0.126,0.382,0.282,0.674,0.44,0.822,0.632,1.002,0.818,1.001,1,1")))
            .add(() => {this.visible = false;})
        this.masterTimeline.add(stopTL);
    }

    private spin(reverse:boolean = true):gsap.core.Timeline {
        const tl = gsap.timeline({
            onComplete: () => {
                this.masterTimeline.add(this.spin(reverse))
            }
        })
        if(!this.shouldStop)
            tl.add(this.step(this.getRandomSymbolInReelSet(), reverse))
        return tl;
    }

    private getSymbolTexturePath(symbolName:string) {
        if(this.isFullCross && this.state == SimpleReelModelState.STOP) {
            return `Cross syms/${symbolName}_${this.reelID}_${this.reelPosition}`;
        } else {
            //return this.state == SimpleReelModelState.SPIN ? "Mz/" + symbolName + "z" : PossessedGameAssets.getSymbolStateTexturePath(symbolName);
            return this.state == SimpleReelModelState.SPIN ? symbolName + "/" + symbolName + "_spin" : PossessedGameAssets.getSymbolStateTexturePath(symbolName);
        }
    }
 
    private step(newSymbolName:string, reverse:boolean = false, stepDuration:number = this.stepDuration, ease:any = "linear"):gsap.core.Tween {
        return gsap.to(this.animatedStepData, {
            duration: stepDuration,
            y: reverse ? -this.stepSize : this.stepSize,
            ease: ease,
            onStart : () => {
                const newSymbolIndex = reverse ? this.symbols.length - 1 : 0;
                this.symbols[newSymbolIndex].texture = Possessed.assetLoader.getTextures(this.getSymbolTexturePath(newSymbolName))[0];
            },
            onUpdate: () => {
                // Move symbols
                this.symbols.forEach((sprite, index) => {
                   sprite.position.y = -this.stepSize + (index * this.stepSize) + this.animatedStepData.y;
                });
            },
            onComplete: () => {
                if(this.firstStep) {
                    this.symbols[1].visible = true;
                    this.firstStep = false;
                }

                if(reverse) {
                    const first = this.symbols.shift();
                    this.symbols.push(<PIXI.Sprite>first);
                } else {
                    const last = this.symbols.pop();
                    this.symbols.unshift(<PIXI.Sprite>last);
                }
                // Update positions
                this.symbols.forEach((sym, index) => {
                    sym.position.y = -this.stepSize + (index * this.stepSize)
                })
                this.animatedStepData.y = 0;
            },
        })
    }

    private getRandomSymbolInReelSet():string {
        const randomIndex = Math.floor(Math.random() * this.reelSet.length);
        return this.reelSet[randomIndex];
    }

    public removeMask() {
        this.removeChild(this.reelMask);
        this.mask = null;
    }
}